import {
  BRING_YOUR_FRIEND_REQUEST,
  BRING_YOUR_FRIEND_SUCCESS,
  BRING_YOUR_FRIEND_ERROR,
  BRING_YOUR_FRIEND_STATUS_REQUEST,
  BRING_YOUR_FRIEND_STATUS_SUCCESS,
  BRING_YOUR_FRIEND_STATUS_ERROR,
  REFERRED_FRIENDS_REQUEST,
  REFERRED_FRIENDS_SUCCESS,
  REFERRED_FRIENDS_ERROR,
  BRING_YOUR_FRIEND_AMOUNT_REQUEST,
  BRING_YOUR_FRIEND_AMOUNT_SUCCESS,
  BRING_YOUR_FRIEND_AMOUNT_ERROR,
  FETCH_PREDICTA_BONUS_CAMPAIGN_REQUEST,
  FETCH_PREDICTA_BONUS_CAMPAIGN_SUCCESS,
  FETCH_PREDICTA_BONUS_CAMPAIGN_FAILURE,
  FETCH_PREDICTA_SUGGESTION_REQUEST,
  FETCH_PREDICTA_SUGGESTION_SUCCESS,
  FETCH_PREDICTA_SUGGESTION_FAILURE,
} from 'Store/constants';

const initialState = {
  bringYourFriend: {
    data: {},
    isLoading: null,
    error: null
  },
  brindYourFriendStatus: {
    data: {},
    isLoading: null,
    error: null
  },
  referredFriend: {
    data: {},
    isLoading: null,
    error: null
  },
  bringYourFriendAmount: {
    data: {},
    isLoading: null,
    error: null
  },
  predictaBonusCampaign: {
    data: {},
    isLoading: null,
    error: null
  },
  predictaSuggestion: {
    data: null,
    isLoading: null,
    error: null
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BRING_YOUR_FRIEND_REQUEST:
      return {
        ...state,
        bringYourFriend: {
          ...state.bringYourFriend,
          isLoading: true,
          error: null
        }
      };

    case BRING_YOUR_FRIEND_SUCCESS:
      return {
        ...state,
        bringYourFriend: {
          ...state.bringYourFriend,
          data: action.payload,
          isLoading: false,
          error: null,
        }
      };

    case BRING_YOUR_FRIEND_ERROR:
      return {
        ...state,
        bringYourFriend: {
          ...state.bringYourFriend,
          isLoading: false,
          error: action.payload,
        }
      };

    case BRING_YOUR_FRIEND_STATUS_REQUEST:
      return {
        ...state,
        brindYourFriendStatus: {
          ...state.brindYourFriendStatus,
          isLoading: true,
          error: null
        }
      };


    case BRING_YOUR_FRIEND_STATUS_SUCCESS:
      return {
        ...state,
        brindYourFriendStatus: {
          ...state.brindYourFriendStatus,
          data: action.payload,
          isLoading: false,
          error: null,
        }
      };

    case BRING_YOUR_FRIEND_STATUS_ERROR:
      return {
        ...state,
        brindYourFriendStatus: {
          ...state.brindYourFriendStatus,
          isLoading: false,
          error: action.payload,
        }
      };

    case REFERRED_FRIENDS_REQUEST:
      return {
        ...state,
        referredFriend: {
          ...state.referredFriend,
          isLoading: true,
          error: null
        }
      };

    case REFERRED_FRIENDS_SUCCESS:
      return {
        ...state,
        referredFriend: {
          ...state.referredFriend,
          data: action.payload,
          isLoading: false,
          error: null,
        }
      };

    case REFERRED_FRIENDS_ERROR:
      return {
        ...state,
        referredFriend: {
          ...state.referredFriend,
          isLoading: false,
          error: action.payload,
        }
      };

    case BRING_YOUR_FRIEND_AMOUNT_REQUEST:
      return {
        ...state,
        bringYourFriendAmount: {
          ...state.bringYourFriendAmount,
          isLoading: true,
          error: null
        }
      };

    case BRING_YOUR_FRIEND_AMOUNT_SUCCESS:
      return {
        ...state,
        bringYourFriendAmount: {
          ...state.bringYourFriendAmount,
          data: action.payload,
          isLoading: false,
          error: null,
        }
      };

    case BRING_YOUR_FRIEND_AMOUNT_ERROR:
      return {
        ...state,
        bringYourFriendAmount: {
          ...state.bringYourFriendAmount,
          isLoading: false,
          error: action.payload,
        }
      };

    case FETCH_PREDICTA_BONUS_CAMPAIGN_REQUEST:
      return {
        ...state,
        predictaBonusCampaign: {
          ...state.predictaBonusCampaign,
          isLoading: true,
          error: null
        }
      };

    case FETCH_PREDICTA_BONUS_CAMPAIGN_SUCCESS:
      return {
        ...state,
        predictaBonusCampaign: {
          ...state.predictaBonusCampaign,
          data: action.payload,
          isLoading: false,
          error: null,
        }
      };

    case FETCH_PREDICTA_BONUS_CAMPAIGN_FAILURE:
      return {
        ...state,
        predictaBonusCampaign: {
          ...state.predictaBonusCampaign,
          isLoading: false,
          error: action.payload,
        }
      };

    case FETCH_PREDICTA_SUGGESTION_REQUEST:
      return {
        ...state,
        predictaSuggestion: {
          ...state.predictaSuggestion,
          isLoading: true,
          error: null
        }
      };

    case FETCH_PREDICTA_SUGGESTION_SUCCESS:
      return {
        ...state,
        predictaSuggestion: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case FETCH_PREDICTA_SUGGESTION_FAILURE:
      return {
        ...state,
        predictaSuggestion: {
          ...state.predictaSuggestion,
          isLoading: false,
          error: action.payload
        }
      };

    default:
      return state;
  }
};
